import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Confluence = (props: TIconProps): ReactElement => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.848057 16.0997C0.621061 16.4698 0.366127 16.8994 0.149608 17.2416C0.0564461 17.399 0.0287669 17.5867 0.0725194 17.7644C0.116272 17.942 0.227964 18.0954 0.383588 18.1915L4.92351 20.9853C5.0024 21.034 5.0902 21.0665 5.18179 21.081C5.27337 21.0954 5.36692 21.0914 5.45696 21.0693C5.547 21.0472 5.63174 21.0074 5.70624 20.9522C5.78073 20.897 5.8435 20.8275 5.89086 20.7478C6.07246 20.444 6.30644 20.0494 6.56137 19.6268C8.35988 16.6584 10.1689 17.0216 13.4306 18.5791L17.9321 20.7199C18.0165 20.7601 18.1081 20.7829 18.2015 20.787C18.2948 20.7911 18.3881 20.7765 18.4757 20.7439C18.5633 20.7114 18.6435 20.6615 18.7115 20.5974C18.7795 20.5333 18.8339 20.4562 18.8715 20.3707L21.0332 15.4815C21.1067 15.3137 21.1112 15.1237 21.0459 14.9526C20.9805 14.7814 20.8506 14.6428 20.684 14.5666C19.7341 14.1195 17.8448 13.229 16.1441 12.4083C10.0257 9.43644 4.82573 9.62852 0.848057 16.0997Z"
      fill="url(#confluence_paint0_linear_439_73148)"
    />
    <path
      d="M21.2042 5.00492C21.4312 4.63474 21.6861 4.2052 21.9026 3.86296C21.9958 3.70553 22.0235 3.51783 21.9797 3.34021C21.936 3.16258 21.8243 3.00922 21.6687 2.91307L17.1287 0.119268C17.0493 0.0657363 16.9596 0.0291317 16.8654 0.0117321C16.7711 -0.00566745 16.6743 -0.00348984 16.581 0.0181295C16.4876 0.0397488 16.3997 0.0803473 16.3227 0.137399C16.2457 0.194451 16.1813 0.266736 16.1335 0.349757C15.9519 0.653582 15.7179 1.04821 15.4629 1.47077C13.6644 4.43918 11.8554 4.07598 8.59369 2.51844L4.10615 0.388172C4.02176 0.348006 3.93018 0.325185 3.83681 0.321059C3.74345 0.316933 3.6502 0.331587 3.5626 0.364152C3.475 0.396716 3.39483 0.44653 3.32683 0.510643C3.25883 0.574755 3.20439 0.651862 3.16674 0.737396L1.00503 5.62654C0.931625 5.79438 0.927094 5.98434 0.992418 6.15549C1.05774 6.32664 1.18769 6.46527 1.35426 6.54151C2.30415 6.98852 4.19346 7.87904 5.89418 8.69972C12.0266 11.6681 17.2265 11.4691 21.2042 5.00492Z"
      fill="url(#confluence_paint1_linear_439_73148)"
    />
    <defs>
      <linearGradient
        id="confluence_paint0_linear_439_73148"
        x1="20.911"
        y1="22.4276"
        x2="7.17601"
        y2="14.5351"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.18" stopColor="hsl(from hsl(217 100% 58%) h s 33%)" />
        <stop offset="1" stopColor="hsl(from hsl(217 100% 58%) h s 51%)" />
      </linearGradient>
      <linearGradient
        id="confluence_paint1_linear_439_73148"
        x1="1.14123"
        y1="-1.32652"
        x2="14.8797"
        y2="6.56945"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.18" stopColor="hsl(from hsl(217 100% 58%) h s 33%)" />
        <stop offset="1" stopColor="hsl(from hsl(217 100% 58%) h s 51%)" />
      </linearGradient>
    </defs>
  </svg>
);
